import './icon.scss';
import { vfSvg } from '../svg/svg.js';


const DEFAULT_VIEW_BOX = '0 0 100 100';

export const CIRCLE = {
    outline: 'outline',
    filled: 'filled',
    none: 'none',
    default: 'none',
};

/**
 * Icons are rendered with SVG as individual components. Use classes to control
 * the size.
 *
 * @markup <vf-exclamation-mark-icon class="vf-icon-small vf-error" circle="outline"></vf-exclamation-mark-icon>
 * @markup <vf-exclamation-mark-icon class="vf-icon-medium"></vf-exclamation-mark-icon>
 * @markup <vf-exclamation-mark-icon class="vf-icon-large"></vf-exclamation-mark-icon>
 * @markup <vf-exclamation-mark-icon class="vf-icon-large vf-error" circle="filled"></vf-exclamation-mark-icon>
 * @markup <vf-exclamation-mark-icon class="vf-icon-large vf-warning" circle="outline"></vf-exclamation-mark-icon>
 * @styleguide components.icons
 */
export const vfIcon = vfSvg.extend({
    props: {
        circle: {
            type: String,
            default: CIRCLE.none,
        },
        title: String,
        description: String,
        size: String,
    },
    data() {
        return {
            viewBox: DEFAULT_VIEW_BOX,
            iconClass: null,
        };
    },
    computed: {
        getClasses() {
            return {
                'vf-icon': true,
                'vf-icon-circle-outline': this.circle === CIRCLE.outline,
                'vf-icon-circle-filled': this.circle === CIRCLE.filled,
                [`vf-icon_${this.name}`]: this.name,
                [`vf-icon-${this.size}`]: this.size,
            };
        },
    },
});

export const vfIconSimpleExtender = (name, graphics, viewBox = DEFAULT_VIEW_BOX, iconClass = false) => ({
    data() {
        return {
            name,
            graphics,
            viewBox,
            iconClass,
        };
    },
    extends: vfIcon,
});
